'use client';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

// Timer function
const calculateTimeLeft = () => {
  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 1); // Tomorrow
  targetDate.setHours(9, 59, 0, 0); // 9:59 AM tomorrow

  const currentDate = new Date();
  const difference = targetDate - currentDate;

  if (difference <= 0) {
    return { hours: 0, minutes: 0, seconds: 0 };
  }

  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return { hours, minutes, seconds };
};

const Header = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <>
      <div className='flex flex-col text-center items-center justify-center text-white z-10 pt-32 pb-12 mobile:pt-24 mobile:pb-8'>
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className='text-[2rem] mobile:text-[1rem] mb-6'
        >
          The event concluded on 29/11/2024.
          <br />
          We would like to extend our sincere thanks to those who attended.
          <br />
          For those who were unable to participate, don't worry — we are
          planning to host similar events in the future,
          <br />
          and we will keep you informed about upcoming opportunities.
        </motion.h1>

        {/* <motion.h1
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className='text-[3rem] mobile:text-[2rem] mb-6'
        >
          Sobha Realty
        </motion.h1> */}

        {/* <motion.h1
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='text-[5rem] mobile:text-[3.5rem] text-extrabold leading-[3rem] mobile:leading-[2.5rem] text-center'
        >
          WHITE FRIDAY
        </motion.h1>

        <motion.h1
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='text-primarycolor text-[4.8rem] mobile:text-[3rem] text-center'
        >
          OPEN HOUSE
        </motion.h1>

        <motion.h1
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className='text-[2rem] mobile:text-[1.5rem] mb-4'
        >
          Villa & Apartment
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='text-[1.1rem] mobile:text-[0.9rem] mb-6'
        >
          Don't miss this extraordinary opportunity to own your dream home with
          Sobha.
        </motion.p> */}

        {/* Registration Deadline */}
        {/* <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='font-bold text-lg mobile:text-sm mb-4'
        >
          Registration ends tomorrow at 9:59 AM!
        </motion.p> */}

        {/* Countdown Timer */}
        {/* <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='text-red-500 font-bold text-[3rem] mobile:text-[1.5rem] mb-6'
        >
          Time left until the event:
          <br />
          <span className=''>
            {timeLeft.hours} hours :
            {timeLeft.minutes < 10
              ? ` 0${timeLeft.minutes} minutes `
              : ` ${timeLeft.minutes} minutes `}
            :
            {timeLeft.seconds < 10
              ? ` 0${timeLeft.seconds} seconds `
              : ` ${timeLeft.seconds} seconds `}
          </span>
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='font-bold text-lg mobile:text-sm mb-4'
        >
          29 November 2024 | Friday | 10AM - 7PM
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
          className='font-bold text-lg mobile:text-sm'
        >
          Sobha Hartland Sales Center
        </motion.p> */}
      </div>
    </>
  );
};

export default Header;
